<template>
	<div class="view-nfl-weekly-pickem-entry-week-page">
		<div class="view-nfl-weekly-pickem-entry-week-page__content">
			<div class="entry-week-data" v-if="entries !== null">
				<div class="header-section">
					<h3 class="pickem-name">{{ this.pickem.name }}</h3>
					<div class="options">
						<select v-model="selectedEntryId" class="entry-select" @change="entryChanged">
							<option v-for="entry in this.formattedEntries" :value="entry.id" :key="entry.id"> {{ entry.name }} </option>
						</select>
						<select v-model="selectedEntryWeekId" class="entry-week-select" @change="entryWeekChanged">
							<option v-for="entryWeek in this.selectedEntry.weeks" :value="entryWeek.id" :key="entryWeek.id">Week {{ entryWeek.week_number }} </option>
						</select>
					</div>
				</div>

				<div class="picks-section">
					<p class="record">Record: {{ wins }} - {{ losses }}</p>
					<div class="team-header">
						<p>Away</p>
						<p>Home</p>
					</div>
				
					<div class="game-row" v-for="(game, index) in sortedGames" :key="index">
						<div class="away-team team" :class="{ correct: game.game_finished && (game.away_participant.score > game.home_participant.score) && game.pick_id == game.away_participant.id, incorrect: game.game_finished && (game.away_participant.score < game.home_participant.score) && game.pick_id == game.away_participant.id}">
							<p :class="{ picked: !game.game_finished && game.away_participant.id == game.pick_id }">{{ game.away_participant.team.nickname }}</p>
							<p class="away-score" :class="{ 'winning-score': game.away_participant.score > game.home_participant.score }" v-if="game.game_finished">{{ game.away_participant.score }}</p>
						</div>
						<div class="home-team team" :class="{ correct: game.game_finished && (game.home_participant.score > game.away_participant.score) && game.pick_id == game.home_participant.id, incorrect: game.game_finished && (game.home_participant.score < game.away_participant.score) && game.pick_id == game.home_participant.id}">
							<p class="home-score" :class="{ 'winning-score': game.home_participant.score > game.away_participant.score }" v-if="game.game_finished">{{ game.home_participant.score }}</p>
							<span v-else></span>
							<p :class="{ picked: !game.game_finished && game.home_participant.id == game.pick_id }">{{ game.home_participant.team.nickname }}</p>
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import { mapMutations } from 'vuex'
	import axios from '@/axios'

	export default {
		props: [ 'pickemId', 'entryId', 'weekId' ],
		data() {
			return {
				pickem: null,
				entries: null,
				entryWeek: null,
				selectedEntryId: null,
				selectedEntryWeekId: null,
			}
		},
		computed: {
			formattedEntries() {
				var entries = []
				this.entries.forEach((entry) => {
					var name = ''
					entry.users.forEach((user, index) => {
						if (index == 0) {
							name = user.user.name
						} else if (index == entry.users.length - 1 && entry.users.length > 2) {
							name = name.concat(user.user.name)
						} else {
							name = name.concat(' / ').concat(user.user.name)
						}
					})
					var wins = 0
					if (this.entryWeek !== null) {
						entry.weeks.forEach((week) => {
							if (week.week_number == this.entryWeek.week_number) {
								wins = week.wins	
							}
						})
					}
				
					entries.push({
						id: entry.id,
						name: name,
						wins: wins
					})
				})
				return entries.sort(function(a,b) {
					return b.wins - a.wins
				})
			},
			selectedEntry() {
				var selectedEntry
				this.entries.forEach((entry) => {
					if (entry.id == this.selectedEntryId) {
						selectedEntry = entry
					}
				})
				return selectedEntry
			},
			sortedGames() {
				if (this.entryWeek !== null) {
					var picks = this.entryWeek.picks

					var filteredPicks = picks.filter(game => game.game_underway == 1)

					return filteredPicks.sort(function(a,b) {
						return a.date_time - b.date_time
					})

				} else {
					return []
				}
			},
			wins() {
				var wins = " "
				this.selectedEntry.weeks.forEach((entryWeek) => {
					if (this.selectedEntryWeekId == entryWeek.id) {
						wins = entryWeek.wins
					}
				})
				return wins
			},
			losses() {
				var losses = " "
				this.selectedEntry.weeks.forEach((entryWeek) => {
					if (this.selectedEntryWeekId == entryWeek.id) {
						losses = entryWeek.losses
					}
				})
				return losses
			}
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED'
			]),
			entryChanged() {
				this.HTTP_IN_PROGRESS()
				var weekNumber = this.entryWeek.week_number
				var newSelectedEntryWeek

				this.entries.forEach((entry) => {
					if (entry.id == this.selectedEntryId) {
						entry.weeks.forEach((week) => {
							if (week.week_number == weekNumber) {
								newSelectedEntryWeek = week.id
							}
						})
					}
				})

				this.getNflWeeklyPickemEntryWeek(this.selectedEntryId, newSelectedEntryWeek).then(() => {
					this.HTTP_FINISHED()
				})
			},
			entryWeekChanged() {
				this.HTTP_IN_PROGRESS()
				this.getNflWeeklyPickemEntryWeek(this.selectedEntryId, this.selectedEntryWeekId).then(() => {
					this.HTTP_FINISHED()
				})
			},
			getNflWeeklyPickem() {
				return axios.get('nfl-weekly-pickems/' + this.pickemId).then((response) => {
					this.pickem = response.data.data
				})
			},
			getNflWeeklyPickemEntries() {
				return axios.get('nfl-weekly-pickems/' + this.pickemId + '/nfl-weekly-pickem-entries').then((response => {
					this.entries = response.data
				}))
			},
			getNflWeeklyPickemEntryWeek(entryId, weekId) {
				return axios.get('nfl-weekly-pickems/' + this.pickemId + '/nfl-weekly-pickem-entries/' + entryId + '/nfl-weekly-pickem-entry-week/' + weekId).then((response) => {
					this.entryWeek = response.data.data
					this.selectedEntryWeekId = this.entryWeek.id
				})
			}
		},
		created() {
			this.HTTP_IN_PROGRESS()
			this.selectedEntryId = this.entryId
			this.selectedEntryWeekId = this.weekId
			this.getNflWeeklyPickem().then(() => {
				this.getNflWeeklyPickemEntries().then(() => {
					this.getNflWeeklyPickemEntryWeek(this.entryId, this.weekId).then(() => {
						this.HTTP_FINISHED()
					})
				})

			}).catch(() => {
				this.HTTP_FINISHED()
				this.$router.replace('/')
			})
		}
	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../../styles/views/nfl/nfl-weekly-pickem/viewEntryWeek';
</style>